import DialogContentText from "@material-ui/core/DialogContentText";
import ActionDialog from "@saleor/components/ActionDialog";
import { ConfirmButtonTransitionState } from "@saleor/components/ConfirmButton";
import React from "react";
import { FormattedMessage, useIntl } from "react-intl";

export interface RegionDeleteDialogProps {
    confirmButtonState: ConfirmButtonTransitionState;
    open: boolean;
    name: string;
    useName?: boolean;
    onConfirm: () => void;
    onClose: () => void;
  }
  
const RegionDeleteDialog: React.FC<RegionDeleteDialogProps> = ({
    name,
    confirmButtonState,
    useName,
    onClose,
    onConfirm,
    open
  }) => {
    const intl = useIntl();
  
    return (
      <ActionDialog
        open={open}
        onClose={onClose}
        confirmButtonState={confirmButtonState}
        onConfirm={onConfirm}
        variant="delete"
        title={intl.formatMessage({
          defaultMessage: "Delete Region",
          description: "dialog title"
        })}
      >
        <DialogContentText>
          {useName ? (
            <FormattedMessage
              defaultMessage='Are you sure you want to delete "{name}" item? If you delete it you won’t be able to assign it to any of the products with  country.'
              values={{
                name
              }}
            />
          ) : (
            <FormattedMessage
              defaultMessage='Are you sure you want to delete "{name}" item?'
              description="delete attribute value"
              values={{
                name
              }}
            />
          )}
        </DialogContentText>
      </ActionDialog>
    );
  };
  export default RegionDeleteDialog;
  